export const setSchedule = (data) => ({type: 'SET_SCHEDULE', data});
export const setSchedulePersonal = (schedule) => ({type: 'SET_SCHEDULE_PERSONAL', schedule});
export const setOrganizationList = (list) => ({type: 'SET_ORGANIZATION_LIST', list});
export const setOrganization = (data) => ({type: 'SET_ORGANIZATION', data});
export const setScheduleDeep = (days) => ({type: 'SET_SCHEDULE_DEEP', days});
export const setTSes = (tSes) => ({type: 'SET_SESSION_TYPE', tSes});
export const setTSesList = (list) => ({type: 'SET_SESSION_TYPES_LIST', list});
export const setHoverRowTitlePosition = (rowTitlePosition) => ({type: 'SET_HOVER_ROW_TITLE', rowTitlePosition});